import axios from 'axios';

// Use the environment variable or fall back to API subdomain
const BASE_URL = process.env.REACT_APP_API_URL || 'https://api.yourbetai.com';

const apiClient = axios.create({
  baseURL: BASE_URL,
  headers: {
    'Content-Type': 'application/json'
  }
});

// Add interceptor for auth token
apiClient.interceptors.request.use(
  (config) => {
    const storedUser = localStorage.getItem('user') || sessionStorage.getItem('user');
    
    if (storedUser) {
      const userData = JSON.parse(storedUser);
      config.headers.Authorization = `Bearer ${userData.token}`;
    }
    
    return config;
  },
  (error) => Promise.reject(error)
);

// Add response interceptor for token refresh
apiClient.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;
    
    // If error is 401 and not already retrying
    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;
      
      try {
        const storedUser = localStorage.getItem('user') || sessionStorage.getItem('user');
        
        if (storedUser) {
          const userData = JSON.parse(storedUser);
          const response = await axios.post(`${BASE_URL}/api/v1/users/refresh-token`, {
            token: userData.token
          });
          
          const newToken = response.data.token;
          userData.token = newToken;
          
          // Update stored user data
          if (localStorage.getItem('user')) {
            localStorage.setItem('user', JSON.stringify(userData));
          } else {
            sessionStorage.setItem('user', JSON.stringify(userData));
          }
          
          // Retry original request with new token
          originalRequest.headers.Authorization = `Bearer ${newToken}`;
          return axios(originalRequest);
        }
      } catch (refreshError) {
        // Token refresh failed, logout user
        localStorage.removeItem('user');
        sessionStorage.removeItem('user');
        window.location.href = '/login';
      }
    }
    
    return Promise.reject(error);
  }
);

export { apiClient };
